"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayContainer = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      _ref$containerElement = _ref.containerElement,
      ContainerElement = _ref$containerElement === void 0 ? 'div' : _ref$containerElement,
      fluid = _ref.fluid,
      fluidSize = _ref.fluidSize,
      formSize = _ref.formSize,
      view = _ref.view,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "containerElement", "fluid", "fluidSize", "formSize", "view"]);

  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, (_classNames = {
      container: !fluid,
      'container-fluid': fluid
    }, _defineProperty(_classNames, "container-form-".concat(formSize), formSize), _defineProperty(_classNames, 'container-view', view), _defineProperty(_classNames, "container-fluid-max-".concat(fluidSize), fluid && fluidSize), _classNames)),
    ref: ref
  }), children);
});

ClayContainer.displayName = 'ClayContainer';
var _default = ClayContainer;
exports.default = _default;